/* eslint-disable*/

import React, { useEffect, useState } from "react";
import Axios from "axios";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "./firebase";
import { v4 } from "uuid";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Navbar from "./Navbar";
import { useHistory } from "react-router-dom";
import Loading from "./Components/Loading";
import { message } from "antd";
import { useTheme } from "@mui/material/styles";
import { useSelector } from "react-redux";

const AddTeam = () => {
  const user = useSelector((states) => states.auth);

  const theme = useTheme();
  const [personName, setPersonName] = useState([]);
  const [names, setNames] = useState([]);

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  function getStyles(name, personName, theme) {
    return {
      fontWeight:
        personName.indexOf(name) === -1
          ? theme.typography.fontWeightRegular
          : theme.typography.fontWeightMedium,
    };
  }

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  const history = useHistory();

  const [name, setName] = useState("");
  const [nameError, setNameError] = useState(false);
  const [macAddress, setMacAddress] = useState("");
  // const [macAddressError, setMacAddressError] = useState(false);
  const [city, setCity] = useState("");
  const [cityError, setCityError] = useState(false);
  const [username, setUsername] = useState("");
  const [usernameError, setUsernameError] = useState(false);
  const [mobile, setMobile] = useState(0);
  const [mobileError, setMobileError] = useState(false);
  const [branch, setBranch] = useState([]);
  const [branchError, setBranchError] = useState(false);
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [profile, setProfile] = useState("");
  const [profileError, setProfileError] = useState(false);
  const [fileNames, setFileNames] = useState([]);
  const [imageUpload, setImageUpload] = useState(null);
  const [imageUrls, setImageUrls] = useState([]);
  const [imgurl, setImgurl] = useState(
    "https://i.pinimg.com/736x/64/81/22/6481225432795d8cdf48f0f85800cf66.jpg"
  );
  const [loading, setLoading] = useState(false);

  const setImageUploadFunction = (file) => {
    setImageUpload(file);
    const imageRef = ref(storage, `images/${file.name + v4()}`);
    uploadBytes(imageRef, file).then((snapshot) => {
      getDownloadURL(snapshot.ref).then((url) => {
        setImageUrls((prev) => [...prev, url]);
        setImgurl(url);
      });
    });
  };

  useEffect(() => {
    document.title = "Add new user";
  }, []);

  const addToList = () => {
    setNameError(false);
    // setMacAddressError(false);
    setCityError(false);
    setUsernameError(false);
    setMobileError(false);
    setEmailError(false);
    setBranchError(false);
    setProfileError(false);

    if (name === "") {
      setNameError(true);
      return;
    }

    if (city === "") {
      setCityError(true);
      return;
    }

    if (username === "") {
      setUsernameError(true);
      return;
    }

    if (mobile.toString().length !== 10) {
      setMobileError(true);
      return;
    }

    if (
      !email
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
    ) {
      setEmailError(true);
      return;
    }

    if (branch === "") {
      setBranchError(true);
      return;
    }

    if (profile === "") {
      setProfileError(true);
      return;
    }

    if (imgurl === "") {
      message.error(`Add Image`);
      return;
    }

    if (personName.includes(user.username)) {
      personName = personName.filter((e) => e !== user.username);
    }

    // this are feilds which is going to be posted
    const Details = {
      Email: email,
      Name: name,
      UserName: username,
      UserType: profile,
      Phone: mobile,
      Image: imgurl,
      City: city,
      Branch: branch,
      Permission: personName,
      MacAddress: macAddress,
    };

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };
    Axios.post("/api/user/registerTeam", Details, config)
      .then(function (response) {
        message.success(" Added successfully");
        setTimeout(function () {
          history.push("/teamlist");
        }, 1000);
      })
      .catch(function (error) {
        message.error(`${error.response.data.message}`);
      });
  };

  const [branchDetail, setBranchDetail] = useState([]);
  const [cities, setCities] = useState([]);

  useEffect(() => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    };
    Axios.get("/api/branch/readAllBranch", config).then((response) => {
      setBranchDetail(response.data.branchs);
    });

    Axios.get("/api/city/readAllCity", config).then((response) => {
      setCities(response.data.citys);
    });

    Axios.get("/api/user/readAllTeamMember", config).then((response) => {
      setNames(response.data.teams);
    });
  }, []);

  const handleDrop = (acceptedFiles) => {
    setFileNames(acceptedFiles.map((file) => file.name));
    setImageUpload(acceptedFiles.target.files[0]);
  };

  return (
    <>
      {loading && <Loading />}
      <Navbar title="Add New User" />
      <div
        className="container-fluid pt-4"
        style={{ backgroundColor: "#F0F2FA" }}
      >
        <div
          style={{
            paddingLeft: "20px",
            paddingBottom: "5px",
            fontSize: "25px",
          }}
        >
          <div className="float-right pr-3">
            {" "}
            <button onClick={addToList} className="btn btn-primary add-button">
              {" "}
              Add Team{" "}
            </button>
          </div>
        </div>
        <div className="row mt-1 mb-4 pl-3">
          <div className="col-lg-12">
            <div className="card" style={{ backgroundColor: "#F3F3F3" }}>
              <div className="card-body">
                <div className="row form-group  " style={{ padding: "5px" }}>
                  <div className="col-lg-3">
                    <TextField
                      className="lead-fields"
                      required
                      fullWidth
                      id="outlined-required"
                      label="Enter Name"
                      onChange={(e) => setName(e.target.value)}
                      error={nameError}
                    />
                  </div>

                  {/* <div className="col-lg-3">
                    <TextField
                      className="lead-fields"
                      required
                      fullWidth
                      id="outlined-required"
                      label="Enter MacAddress"
                      onChange={(e) => setMacAddress(e.target.value)}
                      error={macAddressError}
                    />
                  </div> */}

                  <div className="col-lg-3">
                    <FormControl fullWidth className="lead-fields">
                      <InputLabel id="demo-simple-select-label">
                        City
                      </InputLabel>
                      <Select
                        defaultValue=""
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="City"
                        onChange={(e) => setCity(e.target.value)}
                        error={cityError}
                      >
                        {cities &&
                          cities.map((item, index) => {
                            return (
                              <MenuItem key={index} value={item.CityName}>
                                {item.CityName}
                              </MenuItem>
                            );
                          })}
                      </Select>
                    </FormControl>
                  </div>

                  <div className="col-lg-3">
                    <TextField
                      className="lead-fields"
                      required
                      fullWidth
                      id="outlined-required"
                      label="Enter unique username"
                      onChange={(e) => setUsername(e.target.value)}
                      error={usernameError}
                    />
                  </div>

                  <div className="col-lg-3">
                    <TextField
                      className="lead-fields"
                      required
                      fullWidth
                      type="number"
                      id="outlined-required"
                      label="Enter Phone no"
                      onInput={(e) => {
                        e.target.value = Math.max(0, parseInt(e.target.value))
                          .toString()
                          .slice(0, 10);
                      }}
                      onChange={(e) => setMobile(e.target.value)}
                      error={mobileError}
                    />
                  </div>
                </div>

                <div className="row form-group " style={{ padding: "5px" }}>
                  {/* <div className="col-lg-3">
                    <TextField
                      className="lead-fields"
                      required
                      fullWidth
                      type="password"
                      id="outlined-required"
                      label="Enter Password"
                      onChange={(e) => setPassword(e.target.value)}
                      error={passwordError}
                    />
                  </div> */}

                  <div className="col-lg-3">
                    <TextField
                      className="lead-fields"
                      required
                      fullWidth
                      id="outlined-required"
                      label="Enter Email id"
                      onChange={(e) => setEmail(e.target.value)}
                      error={emailError}
                    />
                  </div>

                  <div className="col-lg-3">
                    <FormControl fullWidth className="lead-fields">
                      <InputLabel id="demo-simple-select-label">
                        Branch
                      </InputLabel>
                      <Select
                        multiple
                        defaultValue={[]}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Branch"
                        onChange={(e) => setBranch(e.target.value)}
                        error={branchError}
                      >
                        {branchDetail &&
                          branchDetail.map((item, index) => {
                            return (
                              <MenuItem key={index} value={item.BranchName}>
                                {item.BranchName}
                              </MenuItem>
                            );
                          })}
                      </Select>
                    </FormControl>
                  </div>

                  <div className="col-lg-3">
                    <TextField
                      className="lead-fields"
                      required
                      fullWidth
                      id="outlined-required"
                      label="Enter User Profile"
                      onChange={(e) => setProfile(e.target.value)}
                      error={profileError}
                    />
                  </div>

                  <div className="col-lg-3">
                    <FormControl fullWidth className="lead-fields">
                      <InputLabel id="demo-multiple-chip-label">
                        Permission
                      </InputLabel>
                      <Select
                        labelId="demo-multiple-chip-label"
                        id="demo-multiple-chip"
                        multiple
                        value={personName}
                        onChange={handleChange}
                        input={
                          <OutlinedInput
                            id="select-multiple-chip"
                            label="Permission"
                          />
                        }
                        renderValue={(selected) => (
                          <Box
                            sx={{
                              maxHeight: "50px",
                              overflow: "scroll",
                            }}
                          >
                            {selected.map((value) => (
                              <Chip key={value} label={value} />
                            ))}
                          </Box>
                        )}
                        MenuProps={MenuProps}
                      >
                        {names &&
                          names.map((name) => (
                            <MenuItem
                              key={name}
                              value={name.Name}
                              style={getStyles(name, personName, theme)}
                            >
                              {name.Name}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </div>
                </div>

                <div className="row form-group " style={{ padding: "5px" }}>
                  <div className="col-lg-3 " style={{ cursor: "pointer" }}>
                    <div className="dropzone lead-fields pt-1 pb-3 pl-3">
                      <input
                        style={{ maxWidth: "90%" }}
                        type="file"
                        accept="image/*"
                        required
                        onChange={(event) => {
                          setImageUploadFunction(event.target.files[0]);
                        }}
                      />
                    </div>
                    <div>
                      <ul>
                        {fileNames.map((fileName) => (
                          <li key={fileName}>{fileName}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddTeam;
